import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBySortNumberPage'
})
export class OrderByNumberPagePipe implements PipeTransform {

  transform(array: any, field: string): any[] {
    if (!Array.isArray(array)) {
      return;
    }
    array.sort((a: any, b: any) => {
      if (a[field]) {
        return a[field] - b[field]

      } else {
        return 0;
      }
    });

    return array;
  }
}